export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20pattern%20with%20warm%20gradients%20in%20soft%20beige%20cream%20and%20amber%20tones%2C%20layered%20flowing%20shapes%20creating%20depth%2C%20minimalist%20corporate%20background%2C%20clean%20modern%20design%2C%20subtle%20texture%2C%20professional%20atmosphere&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="aqdlt 平台背景"
          className="w-full h-full object-cover"
          title="aqdlt 核心服务平台"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/20 to-foreground-950/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-6 leading-tight">
            值得信赖的
            <strong className="text-primary-400"> aqdlt </strong>
            核心服务平台
          </h1>
          <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            aqdlt 提供全方位的数字化服务与解决方案，覆盖综合服务、技术支持、商务合作等多个领域，
            以专业的能力和可靠的产品助力您的业务高效发展。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="/category/zonghe-fuwu"
              className="inline-flex items-center px-8 py-3 text-sm font-medium rounded-full bg-primary-500 text-background-50 transition-all duration-300 hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              探索 aqdlt 服务
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href="/about"
              className="inline-flex items-center px-8 py-3 text-sm font-medium rounded-full border border-background-50/30 text-background-50 transition-all duration-300 hover:bg-background-50/10 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0">
        <div className="w-full px-4 md:px-6 pb-10">
          <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { number: '10,000+', label: '服务企业' },
              { number: '99.9%', label: '平台可用率' },
              { number: '200+', label: '行业解决方案' },
              { number: '50万+', label: '日活用户' },
            ].map((stat) => (
              <div key={stat.label} className="text-center p-4 rounded-lg bg-background-50/10 backdrop-blur-sm">
                <div className="text-xl md:text-2xl font-heading font-bold text-primary-400">{stat.number}</div>
                <div className="text-xs text-background-50/60 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}